import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InvoiceInfo from 'features/invoices/components/InvoiceInfo';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import React from 'react';
import PaymentUsageDTO from '../dtos/PaymentUsageDTO';
import styles from './paymentusagedetail.module.scss';
import { getInvoiceDetailRoute } from 'features/shared/helpers/routeHelper';
import DocumentDownloadButton from 'features/shared/components/documents/DocumentDownloadButton';

interface Props {
  paymentUsage: PaymentUsageDTO;
}

const PaymentUsageDetail = ({ paymentUsage }: Props) => { 
  // private props
  const invoice = paymentUsage.invoiceUsage ? paymentUsage.invoiceUsage : null;
  const paymentDocument = paymentUsage.paymentDocument ? paymentUsage.paymentDocument : null;

  // render
  if (invoice !== null) {
    return (
      <div className="row align-items-center no-gutters">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div className="col-sm-7 col-lg-8">
              <div className="row no-gutters align-items-center">
                <div className="col-sm-7 col-lg-5 pr-3">
                <InvoiceInfo
                    invoiceType={invoice.invoiceType!}
                    invoiceSubType={invoice.invoiceSubType!}
                    commodityDetails={invoice.commodityDetail!}
                    entityLinks={invoice.entityLinks!}
                  />
                </div>
                <div className="col-sm-5 col-lg-7">
                  <div className="row no-gutters align-items-lg-center ">
                    <div className="col-auto col-sm-12 col-lg-6 text-muted text-truncate pr-3">
                      <span className="d-sm-none mr-2 text-muted"><FontAwesomeIcon icon="file-invoice" /></span>
                      <span title={invoice.invoiceNumber}>{invoice.invoiceNumber}</span>
                    </div>
                    <div className={`col-auto col-sm-12 col-lg-6  ${styles.dueDateItem}`}>
                        <span className="d-sm-none mr-2 text-muted"><FontAwesomeIcon icon="clock" /></span>
                        <DateFormatter date={invoice.dueDate!} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-5 col-lg-4">
              <div className="row no-gutters">
                <div className="col-auto col-sm-6 order-1 order-sm-0">
                  <span className="d-sm-none mr-2 text-muted"><FontAwesomeIcon icon="donate" /></span>
                  <PriceFormatter amount={paymentUsage.amount!} currency={invoice.currency!} />
                </div>
                <div className="col-auto col-sm-6 text-truncate text-muted pr-3 pr-sm-0">
                  <span className="d-sm-none mr-2 text-muted"><FontAwesomeIcon icon="file-invoice" /></span>
                  <span title={paymentDocument?.invoiceNumber}>{paymentDocument?.invoiceNumber}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-auto pl-3 ${styles.btnCol}`}>
          <div className="d-flex flex-column flex-lg-row align-items-end align-items-lg-center justify-content-lg-end">
            {paymentDocument?.documentSimplified != null &&
              <div className="mb-2 mb-lg-0 mr-lg-2">
                <DocumentDownloadButton 
                  id={paymentDocument.invoiceId!}
                  icon="file-pdf"
                  documents={paymentDocument?.documentSimplified}
                />
              </div>
            }
            <div>
              <RoundButton asLink to={getInvoiceDetailRoute(invoice.invoiceType!, invoice.invoiceId!, invoice.proformaInvoiceId)} />
            </div>
          </div>
        </div>
      </div>
    )   
  } else {
    return <></>
  }
}

export default PaymentUsageDetail;
